import { useEffect } from 'react';

import dayjs from 'dayjs';

import { gameHasEnded, gameHasStarted } from '@pkg/hooks';

import { useFantasyMetadataStore } from '@app/store/zustand';

export const useGetCompetitionStates = () => {
    const currentGame = useFantasyMetadataStore((state) => state.currentGame);
    const setGameTimesData = useFantasyMetadataStore((state) => state.setGameTimesData);

    const now = dayjs.utc();
    const gameEnded = gameHasEnded(currentGame?.ends_at, now);
    const gameStarted = gameHasStarted(currentGame?.submission_starts_at, now);
    const submissionsClosed = gameHasStarted(currentGame?.submission_ends_at, now);

    useEffect(() => {
        setGameTimesData({
            gameStarted,
            gameEnded,
            submissionsClosed,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameStarted, gameEnded, submissionsClosed]);
};
